import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, CircularProgress, Tab, Tabs } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useSocket } from '../../context/WebSocketContext';

const TradesOrders = () => {
    const { socket, status } = useSocket();

    const [positions, setPositions] = useState([]);
    const [openOrders, setOpenOrders] = useState([]);
    const [orderHistory, setOrderHistory] = useState([]);
    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!socket || status !== 'connected') return;

        const handleMessage = (event) => {
            try {
                const msg = JSON.parse(event.data);
                if (msg.type === 'trade_log') {
                    setPositions(msg.positions || []);
                    setOpenOrders(msg.open_orders || []);
                    setOrderHistory(msg.order_history || []);
                    setLoading(false);
                }
            } catch (err) {
                console.error("Invalid WS message:", event.data);
            }
        };

        socket.addEventListener('message', handleMessage);
        socket.send(JSON.stringify({ type: "trade_log" }));

        return () => socket.removeEventListener('message', handleMessage);
    }, [socket, status]);

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                Trades & Orders
            </Typography>

            <Tabs value={tab} onChange={(e, val) => setTab(val)}>
                <Tab label="Live View" />
                <Tab label="Order History" />
            </Tabs>

            {tab === 0 && (
                <Box display="flex" gap={2} mt={2}>
                    <Box flex={1}>
                        <Typography variant="h6">Active Positions</Typography>
                        {loading ? <CircularProgress /> : (
                            <DataGrid rows={positions} columns={[
                                { field: 'symbol', headerName: 'Symbol', flex: 1 },
                                { field: 'qty', headerName: 'Qty', flex: 1 },
                                { field: 'entry_price', headerName: 'Entry', flex: 1 },
                                { field: 'current_price', headerName: 'Current', flex: 1 },
                                { field: 'pnl', headerName: 'P&L', flex: 1 }
                            ]} autoHeight getRowId={(row) => row._id || row.order_id || row.symbol} />
                        )}
                    </Box>

                    <Box flex={1}>
                        <Typography variant="h6">Pending/Open Orders</Typography>
                        {loading ? <CircularProgress /> : (
                            <DataGrid rows={openOrders} columns={[
                                { field: 'symbol', headerName: 'Symbol', flex: 1 },
                                { field: 'order_type', headerName: 'Order Type', flex: 1 },
                                { field: 'qty', headerName: 'Qty', flex: 1 },
                                { field: 'status', headerName: 'Status', flex: 1 },
                                { field: 'price', headerName: 'Price', flex: 1 }
                            ]} autoHeight getRowId={(row) => row._id || row.order_id || row.symbol} />
                        )}
                    </Box>
                </Box>
            )}

            {tab === 1 && (
                <Paper elevation={2} sx={{ mt: 2, p: 2 }}>
                    <Typography variant="h6">Order History</Typography>
                    {loading ? <CircularProgress /> : (
                        <DataGrid rows={orderHistory} columns={[
                            { field: 'symbol', headerName: 'Symbol', flex: 1 },
                            { field: 'order_type', headerName: 'Order Type', flex: 1 },
                            { field: 'qty', headerName: 'Qty', flex: 1 },
                            { field: 'status', headerName: 'Status', flex: 1 },
                            { field: 'price', headerName: 'Price', flex: 1 }
                        ]} autoHeight getRowId={(row) => row._id || row.order_id || row.symbol} />
                    )}
                </Paper>
            )}
        </Box>
    );
};

export default TradesOrders;
